export function convertArrayToMap(array: Array<{ key: string; value: string }>): Map<string, string> {
    return new Map(array.map(item => [item.key, item.value]));
}

export function move<T>(fromIndex: number, toIndex: number, array: T[]): T[] {
    const result = [...array];
    const [removed] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, removed);
    return result;
}